import { Hand, MapPin } from 'lucide-react';
import { Button, Card, Chip, Description } from '@heroui/react';
import { UserAvatar } from '../../../components/ui/user-avatar';

const SPOTS = [
  {
    code: 'A-12',
    description: 'Bloco A · Apt. 101',
    chip: { label: 'Empréstimo', color: 'success' as const },
  },
  {
    code: 'B-04',
    description: 'Bloco B · Apt. 204',
    chip: { label: 'Aluguel', color: 'accent' as const },
  },
] as const;

const RANKING = [
  { rank: 1, name: 'Ana Souza', score: 42, highlight: false },
  { rank: 2, name: 'Você', score: 31, highlight: true },
  { rank: 3, name: 'Carlos Lima', score: 18, highlight: false },
] as const;

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) {
    return (
      <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-warning/15 text-sm">
        1
      </span>
    );
  }
  return (
    <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-default text-xs font-semibold tabular-nums text-muted">
      {rank}
    </span>
  );
}

export function LandingProductPreview() {
  return (
    <div className="overflow-hidden rounded-2xl border border-separator bg-surface shadow-surface">
      <div className="flex items-center gap-2 border-b border-separator px-4 py-3">
        <span className="size-2.5 rounded-full bg-danger/70" />
        <span className="size-2.5 rounded-full bg-warning/70" />
        <span className="size-2.5 rounded-full bg-success/70" />
        <span className="ml-2 truncate text-xs text-muted">linkpark.app / vagas disponíveis</span>
      </div>

      <div className="grid gap-4 p-4 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)]">
        <div className="flex flex-col gap-3">
          <Description className="text-xs font-medium uppercase tracking-wide">
            Vagas no período
          </Description>
          {SPOTS.map((spot) => (
            <Card key={spot.code}>
              <Card.Header className="flex-row items-start justify-between gap-3 pb-0">
                <div className="min-w-0">
                  <Card.Title className="font-mono text-lg font-bold tracking-tight">
                    {spot.code}
                  </Card.Title>
                  <Card.Description>{spot.description}</Card.Description>
                </div>
                <Chip size="sm" variant="soft" color={spot.chip.color}>
                  {spot.chip.label}
                </Chip>
              </Card.Header>
              <Card.Footer className="grid grid-cols-2 gap-2 pt-3">
                <Button variant="outline" className="pointer-events-none w-full">
                  <MapPin size={16} />
                  Ver no mapa
                </Button>
                <Button variant="primary" className="pointer-events-none w-full">
                  <Hand size={16} />
                  Solicitar
                </Button>
              </Card.Footer>
            </Card>
          ))}
        </div>

        <Card className="h-fit">
          <Card.Header>
            <Card.Title className="text-base">Placar do condomínio</Card.Title>
            <Card.Description>Quem disponibilizou mais</Card.Description>
          </Card.Header>
          <Card.Content className="flex flex-col gap-1 pt-0">
            {RANKING.map((entry) => (
              <div
                key={entry.name}
                className={`flex items-center gap-3 rounded-lg px-2 py-2 ${
                  entry.highlight ? 'bg-accent/10' : ''
                }`}
              >
                <RankBadge rank={entry.rank} />
                <UserAvatar name={entry.name} size="sm" className="shrink-0" />
                <p className="min-w-0 flex-1 text-sm font-medium text-foreground">{entry.name}</p>
                <p className="shrink-0 text-sm font-semibold tabular-nums">
                  {entry.score}
                  <span className="ml-1 text-xs font-normal text-muted">pts</span>
                </p>
              </div>
            ))}
          </Card.Content>
        </Card>
      </div>
    </div>
  );
}
